import Vue from "vue";

import {PersonnelService,} from "./../../common/api.service";
import {DELETE_PERSON_PHONE_NUMBER, FETCH_PERSON_PHONE_NUMBER_LIST, SAVE_NEW_PERSON_PHONE_NUMBER, SAVE_PERSON_PHONE_NUMBER, UPDATE_PERSON_PHONE_NUMBER} from "./actions.js";
import {
    FETCH_PERSON_PHONE_NUMBER_END,
    LOAD_PERSON_PHONE_NUMBER_TO_EDIT,
    LOAD_PERSON_PHONE_NUMBER_TO_VIEW,
    RESET_DEFAULT_NEW_PERSON_PHONE_NUMBER,
    RESET_DEFAULT_PERSON_PHONE_NUMBER_TO_EDIT,
    TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG,
    TOGGLE_NEW_PERSON_PHONE_NUMBER_DIALOG,
    TOGGLE_VIEW_PERSON_PHONE_NUMBER_DIALOG,
    UPDATE_ADD_PERSON_PHONE_NUMBER_FIELD,
    UPDATE_PERSON_PHONE_NUMBER_FIELD
} from "./mutations.js";
import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const getDefaultState = () => {
    return {
        personPhoneNumberList: [],
        viewPersonPhoneNumber: {},
        personPhoneNumber: {
            personId: '',
            contactNumber: '',
            type: '',
            category: '',
            showInContactList: ''
        },
        addPersonPhoneNumber: {
            personId: 0,
            contactNumber: '',
            type: '',
            category: '',
            showInContactList: undefined
        },
        editPersonPhoneNumber: {
            personId: 0,
            contactNumber: '',
            type: '',
            category: '',
            showInContactList: undefined
        },
        defaultPersonPhoneNumber: {
            personId: 0,
            contactNumber: '',
            type: '',
            category: '',
            showInContactList: undefined
        },
        editPersonPhoneNumberDialog: false,
        addPersonPhoneNumberDialog: false,
        viewPersonPhoneNumberDialog: false,
        phoneNumberCategoryList: ['Home', 'Business', 'Unknown'],
        phoneNumberTypeList: ['Mobile', 'Landline', 'Unknown'],
        hasPhoneNumberInContactList: {
            showInContactList: false,
            personPhoneNumberId: undefined
        },
    }
};

const state = getDefaultState();

const getters = {
    hasPhoneNumberInContactList(state) {
        return state.hasPhoneNumberInContactList;
    },
    phoneNumberTypeList(state) {
        return state.phoneNumberTypeList;
    },
    phoneNumberCategoryList(state) {
        return state.phoneNumberCategoryList;
    },
    personPhoneNumberList(state) {
        return state.personPhoneNumberList;
    },
    addPersonPhoneNumberDialog(state) {
        return state.addPersonPhoneNumberDialog;
    },
    editPersonPhoneNumberId(state) {
        if (state.editPersonPhoneNumber !== undefined) {
            return state.editPersonPhoneNumber.personId;
        }
    },
    editPersonPhoneNumberDialog(state) {
        return state.editPersonPhoneNumberDialog;
    },
    personPhoneNumber(state) {
        return state.personPhoneNumber;
    },
    viewPersonPhoneNumberDialog(state) {
        return state.viewPersonPhoneNumberDialog;
    },
    viewPersonPhoneNumber(state) {
        return state.viewPersonPhoneNumber;
    }
};

const actions = {
    [FETCH_PERSON_PHONE_NUMBER_LIST]({commit}, personId) {
        if (personId == undefined) {
            return false;
        }
        return PersonnelService.getPersonPhoneNumbers(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_PHONE_NUMBER_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch phone numbers'});
            });
    },

    [UPDATE_PERSON_PHONE_NUMBER]({commit, dispatch}, params) {


        return PersonnelService.updatePersonPhoneNumber(state.editPersonPhoneNumber)
            .then(({data}) => {
                commit(RESET_DEFAULT_PERSON_PHONE_NUMBER_TO_EDIT);
                dispatch(FETCH_PERSON_PHONE_NUMBER_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update phone numbers'});
            });
    },

    [SAVE_NEW_PERSON_PHONE_NUMBER]({commit, dispatch}) {

        //Put this here as it will get lost with reset
        const newPersonPhoneNumber = state.addPersonPhoneNumber;
        return PersonnelService.savePersonPhoneNumber(newPersonPhoneNumber)
            .then(() => {

                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_PHONE_NUMBER_LIST, newPersonPhoneNumber.personId);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save phone numbers'});
            });
    },

    // Update
    [SAVE_PERSON_PHONE_NUMBER]({dispatch, commit}) {
        return PersonnelService.updatePersonPhoneNumber(state.editPersonPhoneNumber)
            .then(({data}) => {
                // commit(TOGGLE_PERSON_PHONE_NUMBER_EDIT_STATE, params.field);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                dispatch(FETCH_PERSON_PHONE_NUMBER_LIST, state.editPersonPhoneNumber.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update phone numbers'});
            });
    },

    [DELETE_PERSON_PHONE_NUMBER]({dispatch, commit}, params) {

        return PersonnelService.deletePersonPhoneNumber(params.personPhoneNumberId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_PHONE_NUMBER_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete phone number'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_VIEW_PERSON_PHONE_NUMBER_DIALOG](state) {
        state.viewPersonPhoneNumberDialog = !state.viewPersonPhoneNumberDialog;
    },
    [TOGGLE_NEW_PERSON_PHONE_NUMBER_DIALOG](state) {
        state.addPersonPhoneNumberDialog = !state.addPersonPhoneNumberDialog;
    },
    [TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG](state) {

        state.editPersonPhoneNumberDialog = !state.editPersonPhoneNumberDialog;
    },
    [RESET_DEFAULT_NEW_PERSON_PHONE_NUMBER](state, personId) {
        state.addPersonPhoneNumber = getDefaultState().defaultPersonPhoneNumber;

        state.addPersonPhoneNumber.personId = personId;
    },
    [RESET_DEFAULT_PERSON_PHONE_NUMBER_TO_EDIT](state) {
        state.editPersonPhoneNumber = state.defaultPersonPhoneNumber;
    },

    [LOAD_PERSON_PHONE_NUMBER_TO_EDIT](state, personPhoneNumberId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personPhoneNumberList.find((list) =>
            list.personPhoneNumberId == personPhoneNumberId);
        state.editPersonPhoneNumber = itemToEdit;
    },

    [LOAD_PERSON_PHONE_NUMBER_TO_VIEW](state, personPhoneNumberId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToView = state.personPhoneNumberList.find((list) =>
            list.personPhoneNumberId == personPhoneNumberId);
        state.viewPersonPhoneNumber = itemToView;
    },

    [UPDATE_ADD_PERSON_PHONE_NUMBER_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonPhoneNumber[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonPhoneNumber[data.key] = data.value;
        }
    },

    [UPDATE_PERSON_PHONE_NUMBER_FIELD](state, data) {
        state.editPersonPhoneNumber[data.field] = data.value;
    },

    [FETCH_PERSON_PHONE_NUMBER_END](state, data) {

        state.hasPhoneNumberInContactList.personPhoneNumberId = undefined;
        state.hasPhoneNumberInContactList.showInContactList = false;
        for (let phoneNumber of data) {
            if (phoneNumber.showInContactList) {
                state.hasPhoneNumberInContactList.personPhoneNumberId = phoneNumber.personPhoneNumberId;
                state.hasPhoneNumberInContactList.showInContactList = true;
            }
        }

        state.personPhoneNumberList = data;
        //state.articlesCount = articlesCount;
        state.isLoading = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
